<div class="main-info" *ngIf="!loading && itemDetails">


  <ng-container *ngIf="false">
    <div class="img">
      <div class="actionsIcon" *ngIf="userInfo?.user?.role_code=='Admin' && itemDetails?.showActions">
        <button mat-icon-button [matMenuTriggerFor]="auctionMenu" class="btnLight_fill rounded-circle more-action"><svg
            xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4">
            <path id="Path_19055" data-name="Path 19055"
              d="M6,10a2,2,0,1,0,2,2A2.006,2.006,0,0,0,6,10Zm12,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,18,10Zm-6,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z"
              transform="translate(-4 -10)" fill="#70639e" />
          </svg>
        </button>

        <mat-menu #auctionMenu="matMenu">
          <button mat-menu-item (click)=" onEditAuction()">
            {{ "Auctions.Edit"| translate}}
          </button>
          <button *ngIf="itemDetails.is_published" (click)="publishAuction(1)" mat-menu-item>
            {{'items-requests.Unpublish' | translate}}
          </button>
          <button *ngIf="!itemDetails.is_published" (click)="publishAuction(0)" mat-menu-item>
            {{'items-requests.publish' | translate}}
          </button>
          <button (click)="DeleteAuction()" mat-menu-item>
            <span class="text-danger">{{'items-requests.Delete' | translate}}</span>
          </button>



        </mat-menu>
      </div>
      <img [src]="itemDetails?.main_image" onerror="this.src='assets/images/default-img.png'" alt="">
      <div class="item_status" *ngIf="itemDetails.is_closed">
        <ng-container *ngIf="itemDetails?.winner; else elseTemplate">
          <!-- Winner Is <b>{{itemDetails?.winner?.firstname + " " + itemDetails?.winner?.lastname}}</b> -->
          <div class="auction-badge">

            <div class="badge-img rounded-circle" style="overflow: hidden;">
              <img *ngIf="itemDetails?.winner?.image" [src]="itemDetails?.winner?.image"
                (error)='itemDetails?.winner.image = ""'>
              <span *ngIf="!itemDetails?.winner?.image">
                {{(itemDetails?.winner?.firstname+' '+itemDetails?.winner?.lastname)|
                shortName }}</span>
            </div>
            <div class="badge-text">
              <p class="head">{{'items-requests.Auction winner' | translate}}</p>
              <p class="name" (click)="_config.goTo('/admin/usersManagement/users/profile/'+itemDetails?.winner?.id)">
                {{(itemDetails?.winner?.firstname + ' '
                +itemDetails?.winner?.lastname ) | titlecase }} </p>
            </div>
          </div>
        </ng-container>
        <ng-template #elseTemplate>
          <div class="auction-badge">
            <div class="badge-text">
              <p class="head">{{'Auction Item.The auction has ended' | translate}}</p>
              <p class="name">{{'items-requests.With No Winner' | translate}} </p>
            </div>
          </div>
        </ng-template>

      </div>
    </div>

    <div class="name">{{itemDetails?.name}}</div>

    <span class="badge rounded-pill bg-secondary">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
        <g id="category_ic" transform="translate(-839 -1942.867)">
          <rect id="Container" width="12" height="12" transform="translate(839 1942.867)" fill="none"></rect>
          <path id="category"
            d="M6874.252,14872.064a2.7,2.7,0,0,1-.8-1.971,2.722,2.722,0,1,1,.8,1.971Zm.856-3.085a1.605,1.605,0,1,0,1.115-.454A1.492,1.492,0,0,0,6875.108,14868.979Zm-7.415,3.507a.68.68,0,0,1-.495-.2.7.7,0,0,1-.2-.494v-3.472a.7.7,0,0,1,.2-.491.69.69,0,0,1,.495-.2h3.473a.681.681,0,0,1,.5.208.7.7,0,0,1,.2.491v3.468a.685.685,0,0,1-.695.694Zm.5-1.2h2.469v-2.468H6868.2Zm2.275-5.442a.678.678,0,0,1-.609-.357.639.639,0,0,1,.021-.71l2.222-3.586a.653.653,0,0,1,.584-.329.679.679,0,0,1,.6.325l2.222,3.594a.64.64,0,0,1,.014.706.677.677,0,0,1-.609.357Zm.9-1.2h2.656l-1.33-2.136Z"
            transform="translate(-6027.999 -12917.998)" fill="#ed793e"></path>
        </g>
      </svg>
      {{itemDetails?.category?.name}}
    </span>
    <div class="mb-2 description-txt" IsAdmin>
      <span [ngSwitch]="itemDetails?.is_published">
        <p *ngSwitchCase="1" class="published">
          {{'Main Auction.published' | translate}}
        </p>
        <p *ngSwitchCase="0" class="unpublished">
          {{'items-requests.Unpublished' | translate}}
        </p>
        <p *ngSwitchDefault class="unpublished">
          {{'items-requests.Unpublished' | translate}}
        </p>
      </span>
    </div>
    <div class="description-txt"> {{itemDetails?.description}}</div>

    <div *ngIf="userInfo?.user?.role_code !='General' && userInfo">
      <div #Details class="item-details">
        <h2 class="head">{{"Auction Item.Item Details"|translate}}</h2>
        <ng-container *ngFor="let item of itemDetails.details; let even = even">
          <div class="item" [class.item-bg]="even">
            <span class="title" appSelectTranslatedText [EnKey]="item.key_en" [ArKey]="item.key_ar"> </span>
            <span class="value" appSelectTranslatedText [EnKey]="item.value_en" [ArKey]="item.value_ar"></span>
          </div>
        </ng-container>

      </div>

      <div #Media class="item-media">
        <h2 class="head">{{"Auction Item.Media"|translate}}</h2>

        <owl-carousel-o [options]="customOptions">
          <ng-template *ngFor="let slide of slider;let i = index" carouselSlide>
            <ng-container *ngIf="slide.type === 'video'; else elseTemplate">
              <div class="carousel_item video" gallerize dir="ltr"
                (click)=" lightbox.open(i, 'lightbox' , {panelClass: 'fullscreen'})">

                <video src="{{slide.path}}" [controls]="false" muted></video>
              </div>
            </ng-container>
            <ng-template #elseTemplate>
              <div class="carousel_item" gallerize dir="ltr">
                <img (click)=" lightbox.open(i, 'lightbox' , {panelClass: 'fullscreen'})" src="{{slide.path}}" alt="">
              </div>
            </ng-template>


          </ng-template>
        </owl-carousel-o>
      </div>
    </div>
    <div class="show-item" *ngIf="userInfo?.user?.role_code =='General'|| !userInfo">
      <button mat-button class="btn join"
        (click)="OnShowItemDetails()">{{"multiAuction.fullDetailes"|translate}}</button>
    </div>

  </ng-container>

  <div class="container-fluid">
    <div class="details_card row">
      <div class="card_img col-md-4 p-0">

        <img [src]="itemDetails?.main_image" onerror="this.src='assets/images/default-img.png'" alt="">
        <div class="item_status" *ngIf="itemDetails?.is_closed" IsAdmin>
          <ng-container *ngIf="itemDetails?.winner; else elseTemplate">
            <!-- Winner Is <b>{{itemDetails?.winner?.firstname + " " + itemDetails?.winner?.lastname}}</b> -->
            <div class="auction-badge">

              <div class="badge-img rounded-circle" style="overflow: hidden;">
                <img *ngIf="itemDetails?.winner?.image" [src]="itemDetails?.winner?.image"
                  (error)='itemDetails?.winner.image = ""'>
                <span *ngIf="!itemDetails?.winner?.image">
                  {{(itemDetails?.winner?.firstname+' '+itemDetails?.winner?.lastname)|
                  shortName }}</span>
              </div>
              <div class="badge-text">
                <p class="head">{{'items-requests.Auction winner' | translate}}</p>
                <p class="name">
                  {{(itemDetails?.winner?.firstname + ' '
                  +itemDetails?.winner?.lastname ) | titlecase }} </p>
              </div>
            </div>
          </ng-container>
          <ng-template #elseTemplate>
            <div class="auction-badge">
              <div class="badge-text">
                <p class="head">{{'Auction Item.The auction has ended' | translate}}</p>
                <p class="name">{{'items-requests.With No Winner' | translate}} </p>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="card_content col-md-8">
        <div class="title">{{itemDetails?.name}}</div>
        <div class="desc" rowOutlet="4">{{itemDetails?.description}}</div>
        <p class="category">
          <span class="badge rounded-pill bg-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
              <g id="category_ic" transform="translate(-839 -1942.867)">
                <rect id="Container" width="12" height="12" transform="translate(839 1942.867)" fill="none"></rect>
                <path id="category"
                  d="M6874.252,14872.064a2.7,2.7,0,0,1-.8-1.971,2.722,2.722,0,1,1,.8,1.971Zm.856-3.085a1.605,1.605,0,1,0,1.115-.454A1.492,1.492,0,0,0,6875.108,14868.979Zm-7.415,3.507a.68.68,0,0,1-.495-.2.7.7,0,0,1-.2-.494v-3.472a.7.7,0,0,1,.2-.491.69.69,0,0,1,.495-.2h3.473a.681.681,0,0,1,.5.208.7.7,0,0,1,.2.491v3.468a.685.685,0,0,1-.695.694Zm.5-1.2h2.469v-2.468H6868.2Zm2.275-5.442a.678.678,0,0,1-.609-.357.639.639,0,0,1,.021-.71l2.222-3.586a.653.653,0,0,1,.584-.329.679.679,0,0,1,.6.325l2.222,3.594a.64.64,0,0,1,.014.706.677.677,0,0,1-.609.357Zm.9-1.2h2.656l-1.33-2.136Z"
                  transform="translate(-6027.999 -12917.998)" fill="#ed793e"></path>
              </g>
            </svg>
            {{itemDetails?.category?.name}}
          </span>
        </p>

        <div class="group_btn">
          <button mat-button class="btnLight_fill" (click)="OnShowItemDetails()">
            {{"multiAuction.View Full Details"|translate}}</button>
          <button mat-icon-button [matMenuTriggerFor]="auctionMenu"
            *ngIf="userInfo?.user?.role_code=='Admin' && itemDetails?.showActions"
            class="btnLight_fill rounded-circle more-action"><svg xmlns="http://www.w3.org/2000/svg" width="16"
              height="4" viewBox="0 0 16 4">
              <path id="Path_19055" data-name="Path 19055"
                d="M6,10a2,2,0,1,0,2,2A2.006,2.006,0,0,0,6,10Zm12,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,18,10Zm-6,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z"
                transform="translate(-4 -10)" fill="#70639e" />
            </svg>
          </button>

          <mat-menu #auctionMenu="matMenu">
            <button mat-menu-item (click)=" onEditAuction()">
              {{ "Auctions.Edit"| translate}}
            </button>
            <button *ngIf="itemDetails.is_published" (click)="publishAuction(1)" mat-menu-item>
              {{'items-requests.Unpublish' | translate}}
            </button>
            <button *ngIf="!itemDetails.is_published" (click)="publishAuction(0)" mat-menu-item>
              {{'items-requests.publish' | translate}}
            </button>
            <button (click)="DeleteAuction()" mat-menu-item>
              <span class="text-danger">{{'items-requests.Delete' | translate}}</span>
            </button>



          </mat-menu>

        </div>
      </div>
    </div>
  </div>





  <div class="biding_place live-bidding">
    <div class="title-bides" *ngIf="itemDetails?.is_closed"> {{"Auction Item.Placed Bids"|translate}} </div>
    <div class="live" *ngIf="activeAuctionWork == itemDetails?.id && !itemDetails?.is_closed">
      <!-- <div class="live" *ngIf="auctionStatus != 'end'"> -->
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
        <circle id="circle" cx="3" cy="3" r="3" fill="red" />
      </svg>
      {{"Auction Item.Live bidding"|translate}}
    </div>
    <div class="live-users">
      <div *ngIf="bidders?.length == 0" class="nobadding">
        <div class="no-bid text-center">
          <img src="assets/images/icons/no-biding.svg" alt="" srcset="">
          <ng-container *ngIf="itemDetails?.is_closed || activeAuctionWork == itemDetails?.id; else elseTemplate22">
            <p class="no-bid-txt">{{"Auction Item.No bidding added yet"|translate}}</p>
          </ng-container>
          <ng-template #elseTemplate22>
            <p class="no-bid-txt">{{"multiAuction.Once the auction begins, bidding will be displayed
              here."|translate}}
            </p>

          </ng-template>

        </div>
      </div>

      <ng-container *ngIf="bidders?.length > 0 ">

        <div *ngFor="let bidder of bidders" class="user">
          <div class="info">
            <div class="img">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                <g id="Avatar" transform="translate(-1130)">
                  <circle id="User-Photo" cx="20" cy="20" r="20" transform="translate(1130)" fill="#ebe9f1" />
                  <path id="user_ic"
                    d="M167.5,282.246a3.372,3.372,0,0,1-2.531-1.014,3.949,3.949,0,0,1,0-5.217,3.665,3.665,0,0,1,5.062,0,3.949,3.949,0,0,1,0,5.217A3.372,3.372,0,0,1,167.5,282.246ZM161.406,290a1.336,1.336,0,0,1-1-.423,1.419,1.419,0,0,1-.41-1.027v-.821a2.717,2.717,0,0,1,.445-1.57,2.883,2.883,0,0,1,1.148-.99,17.274,17.274,0,0,1,3.012-1.087,11.832,11.832,0,0,1,2.895-.362,11.336,11.336,0,0,1,2.883.374,19.572,19.572,0,0,1,3,1.075,2.847,2.847,0,0,1,1.172.99,2.717,2.717,0,0,1,.445,1.57v.821a1.419,1.419,0,0,1-.41,1.027,1.336,1.336,0,0,1-1,.423Z"
                    transform="translate(982.49 -262)" fill="#322075" />
                </g>
              </svg>
            </div>
            <div class="price-date">
              <p class="name" *ngIf="bidder?.userID == userInfo?.user?.id">{{"Auction Item.You"|translate}}</p>
              <p class="name" *ngIf="bidder?.userID != userInfo?.user?.id">
                {{ bidder?.is_anonymous ? ("Auction Item.Aonymous Bidder"|translate) :(bidder.username |
                titlecase)}}</p>
              <p class="date">{{bidder.createdAt | dateUTC:"MMM d, y, h:mm:ss a" }}</p>
            </div>
          </div>

          <div class="price">
            <span>{{"Auction Item.SR"|translate}}</span> {{bidder.price}}
          </div>

        </div>

      </ng-container>
    </div>

  </div>


</div>

<app-loading *ngIf="loading"></app-loading>